export default {
  namespaced: true,
  state: {
    key: null,
    serverResponse: {},
    defaultMessage: null
  },
  mutations: {
    set(state, error) {
      state.key = error.key;
      state.serverResponse = error.serverResponse;
      state.defaultMessage = error.defaultMessage;
    },
    reset(state) {
      state.key = null;
      state.serverResponse = {};
      state.defaultMessage = null;
    }
  }
};
